import { DIAGRAM_COLOR_PALETTE, normalizeDiagramColor } from '@ukrop-nm/shared';
import { UkropTip } from '../tooltips/DiagramTooltipContext';

export function ColorSwatchPicker({
  value,
  disabled,
  onChange,
  label = 'Колір',
}: {
  value?: string;
  disabled?: boolean;
  onChange: (hex: string | undefined) => void;
  label?: string;
}) {
  const current = normalizeDiagramColor(value) ?? '';

  return (
    <div className="field">
      <label>{label}</label>
      <div className="color-swatch-row" role="listbox" aria-label={label}>
        {DIAGRAM_COLOR_PALETTE.map((c) => {
          const selected = c.hex === '' ? current === '' : current === c.hex;
          return (
            <UkropTip key={c.id} text={c.labelUk}>
              <button
                type="button"
                role="option"
                aria-selected={selected}
                disabled={disabled}
                className={`color-swatch${selected ? ' is-selected' : ''}${c.hex === '' ? ' is-default' : ''}`}
                style={c.hex ? { backgroundColor: c.hex } : undefined}
                onClick={() => onChange(c.hex ? c.hex : undefined)}
              />
            </UkropTip>
          );
        })}
      </div>
      <span className="text-theme-xs text-gray-500 dark:text-gray-400">
        {DIAGRAM_COLOR_PALETTE.find((c) => (c.hex === '' ? current === '' : c.hex === current))
          ?.labelUk ?? 'Користувацький'}
      </span>
    </div>
  );
}
